import { Reducer } from 'redux';
import { PURGE } from 'redux-persist';
import { SearchHistory, SearchState, SearchTypes } from './types';

const INITIAL_STATE: SearchState = {
    data: {
        term: '',
        lastTerm: '',
        history: [] as SearchHistory[],
        suggestions: [] as string[],
    },
    doSearch: false,
    loading: false,
    hasError: false,
};

const reducer: Reducer<SearchState> = (state: SearchState = INITIAL_STATE, action) => {
    switch (action.type) {
        case PURGE:
            return { ...INITIAL_STATE };
        case 'persist/REHYDRATE':
            const { term, lastTerm } = action.payload && action.payload.search ? action.payload.search.data : state.data;
            return { ...state, data: { ...state.data, term, lastTerm } };
        case SearchTypes.SEARCH_CHANGE:
            return { ...state, doSearch: false, data: { ...state.data, term: action.payload } };
        case SearchTypes.SEARCH_SUBMIT:
            return { ...state, doSearch: true, data: { ...state.data, lastTerm: state.data.term } };
        case SearchTypes.SEARCH_CLEAR:
            return { ...state, doSearch: false, data: { ...state.data, term: '' } };
        case SearchTypes.GET_SEARCH_HISTORY_REQUEST:
            return { ...state, loading: true };
        case SearchTypes.GET_SEARCH_HISTORY_SUCCESS:
            return {
                ...state,
                loading: false,
                hasError: false,
                data: { ...state.data, history: action.payload.listOfSearchHistory },
            };
        case SearchTypes.GET_SEARCH_HISTORY_FAILURE:
            return { ...state, loading: false, hasError: true };
        case SearchTypes.DELETE_SEARCH_HISTORY_SUCCESS:
            return { ...state, data: { ...state.data, history: [] } };
        case SearchTypes.DELETE_SEARCH_HISTORY_FAILURE:
            return { ...state, loading: false, hasError: true };
        case SearchTypes.GET_SEARCH_SUGGESTIONS_REQUEST:
            return { ...state, loading: true };
        case SearchTypes.GET_SEARCH_SUGGESTIONS_SUCCESS:
            return {
                ...state,
                loading: false,
                hasError: false,
                data: {
                    ...state.data,
                    suggestions: action.payload.listOfSuggestions,
                },
            };
        case SearchTypes.GET_SEARCH_SUGGESTIONS_FAILURE:
            return { ...state, loading: false, hasError: true };
        case SearchTypes.CLEAR_SUGGESTIONS_LIST:
            return { ...state, data: { ...state.data, suggestions: [] } };
        default:
            return state;
    }
};

export default reducer;
